import React from "react";
import { Steps, Popover, Progress, DatePicker, Select } from 'antd';
import services from '../../../services';
import WizardModalForm from '../../../components/common/wizard_modal_form';
import Main from '../../../Pages/Demo/main';
import { toast } from 'react-toastify';
import { Button } from '@progress/kendo-react-buttons'
import Lang from '../../../lang'
import LegalFrameWorkModal from '../../../components/common/matrixArticleModalForm'
import { Input } from '@progress/kendo-react-inputs';
import Calculator from '../../../components/common/calculator/Calculator';
import RowDeatils from '../../../components/common/RowDeatils';
import Inserirvasilha from '../../../components/modules/vasilha/Inserirvasilha';
import InstalaCaovinicaTables from './InstalaCaovinicaTables';
import InserirInstalacaoVínica from './InserirInstalacaoVínica';
import LocationFunction from '../../../components/common/LocationFunction.jsx';
import { post } from 'jquery';
import HistoryPanel from './histroyPanel';
import queryString from 'query-string';
import $ from "jquery";


const { Option } = Select

var moment = require('moment')
const dateFormat = "YYYY-MM-DD";

const { Step } = Steps;
const customDot = (dot, { title }) => (
    <Popover
        content={
            <span>
                {title}
            </span>
        }
    >
        {dot}
    </Popover>
);
const ArrayDataFields = [];
const arrayAtividade = [];
const arrayTipoInstalacao = [];
var tiposInstalacao = [];
var atividades = [];
var coddis = '';
var codcon = '';
var codfrg = '';
var firstTime = true;
var countLocationTimes = 0

const estadoDropdown = [
    {
        value: 1,
        name: "ativo"
    },
    {
        value: 2,
        name: "inativo"
    }
]

const localArmazenagemDropdown = [
    {
        value: 1,
        name: "Gaia"
    },
    {
        value: 2,
        name: "Douro"
    },
    {
        value: 3,
        name: "Resto do País"
    },
    {
        value: 4,
        name: "Outro País"
    }
]

const ParcelPointFactors = {
    "fplocalizacao": "location",
    "fpaltitude": "Altitude",
    "fpexposicao": "Exposure",
    "fpinclinacao": "Inclination",
    "fpabrigo": "shelter",
    "fpnaturterreno": "Nat.Terrenno",
    "fppedregosidade": "stony",
    "fpcastas": "grapevarieties",
    "fpidadevinha": "vineage",
    "fpprodutividade": "productivity",
    "fpcompasso": "compass",
    "fparmacao": "wire"
};

const parcelSettlementCharacteristics = {
    "compasso": "Compass",
    "densidade": "Densidade",
    "prctLss3AndFailures": "PrLss3AndFailures",
    "prctfaults": "perfaults",
    "pesmaioR3": "PesGtr3years",
    "pesmenoR3": "pesLss3years",
    "pesilegais": "Illegalfeet",
    "pestotals": "Pestotals",
    "pesramleg": "CoolRamada",
    "falhasram": "Ramadafemales",
    "pesfalileg": "Illegalfaults",
    "pesfalleg": "Legalfaults",
    "pescastasnaoaptas": "Pesvarietiesnotsuitable",
    "pessemaramacao": "Feetwithoutwire",
    "armacaoterreno": "armacaoterreno"
};

const ParcelPopulationDetails = {
    "bacelos": "bacon",
    "enxertoS1": "Grafts1year",
    "videiraS2": "Vines2years",
    "videiraS3": "Vines3years",
    "videiraS4A25": "Vines4to25years",
    "videirasmaioR25": "Vines>25years"
};

const ParcelPopulationDetailsSemEnqLegal = {
    "bacelosileg": "bacon",
    "enxertoS1ILEG": "Grafts1year",
    "videiraS2ILEG": "Vines2years",
    "videiraS3ILEG": "Vines3years",
    "videiraS4A25ILEG": "Vines4to25years",
    "videirasmaioR25ILEG": "Vines>25years"
};
const castasInputs = {
    "pcttinta": "Casta tinta",
    "pctbranca": "Casta branca",
    "pctrose": "Casta rose",
    "pctmoscatel": "Casta moscatel"
};


const combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

const intConst = {
    //"numparc": 1,
    //"geocod": 1,
    "areapotential": 1,
    "areaeffective": 1,
    "areaeqlegal": 1,
    "fatordporto": 1,
    "fatoraptidao": 1,
    "fatorporto": 1,
    "papv": 1,
    "portal": 1,
    "sitdeclar": 1,
    "mcp": 1,
    "legalizavel": 1,
    "pontuacao": 1,
    "idsitparc": 1,
    "anoplantacao": 1,
    "idtpestadovinha": 1,
    "groudFrame": 1,
    "estimatedProduction": 1,
    "codlitigio": 1,
    "idclasseplant": 1,
    "potentialarea": 1,
    "affectiveArea": 1,
    "areaWithoutEnqNice": 1,
    "doPort": 1,
    "fitnessFactor": 1,
    "factorPortGrapeVarieties": 1,
    "parcelid": 1,
    "fplocalizacao": 1,
    "fpaltitude": 1,
    "fpexposicao": 1,
    "fpinclinacao": 1,
    "fpabrigo": 1,
    "fpnaturterreno": 1,
    "fppedregosidade": 1,
    "fpcastas": 1,
    "fpidadevinha": 1,
    "fpprodutividade": 1,
    "fpcompasso": 1,
    "fparmacao": 1,
    //"compasso": 1,
    "densidade": 1,
    "prctLss3AndFailures": 1,
    "prctfaults": 1,
    "pesmaioR3": 1,
    "pesmenoR3": 1,
    "pesilegais": 1,
    "pestotals": 1,
    "pesramleg": 1,
    "falhasram": 1,
    "pesfalileg": 1,
    "pesfalleg": 1,
    "pescastasnaoaptas": 1,
    "pessemaramacao": 1,
    "type": 1,
    "bacelos": 1,
    "enxertoS1": 1,
    "videiraS2": 1,
    "videiraS3": 1,
    // "vines4Years": 1,
    "videiraS4A25": 1,
    "videirasmaioR25": 1,
    "pcntRedvariety": 1,
    "pcntwhiteVariety": 1,
    "pcntMuscatGrapeVariety": 1,
    "pctmoscatel": 1,
    "pcntRoseVariety": 1,
    "pcttinta": 1,
    "pctbranca": 1,
    "pctrose": 1,
    "nrartigo": 1
}

const ReadOnly = {
    'classe': 1,
    'areaeqlegal': 1,
    'areaeffective': 1,
    'areapotential': 1,
    'pestotals': 1,
    'prctfaults': 1,
    'prctLss3AndFailures': 1,
    'densidade': 1,
    'pctbranca': 1,
    'pcttinta': 1,
    'pctrose': 1
}

const textDigitOnly = [
    "geocodigo",
    "areaCoberta",
    'morada',
    "lugar",
    //"codigoPostalExtenso",
    "codigoPostal",

]


const createTableModule = ['castaparc', "matrixArticle"]
class WizardVínica extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            datePicker: "",
            ivvData: {},
            formData: {},
            ParcelPointFactorsdivs: "",
            parcelSettlementCharacteristicsdivs: "",
            ParcelPopulationDetailsdivs: "",
            ParcelPopulationDetailsSemEnqLegaldivs: "",
            CastasInputs: "",
            sel_nev: "",
            detailPopUp: "",
            stepNumber: 0,
            auditList: [],
            telkikTable: {},
            matrixlist: [],
            ArrayDataFields: [],
            arrayAtividade: [],
            arrayTipoInstalacao: [],
            tiposInstalacao: [],
            busentconcelho: [],
            tiposAtividadeIVV: [],
            BusEntFreguesia: [],
            activeIndex: 'step0',
            totalDouro: 0,
            totalPorto: 0,
            legalarray: [],
            levantamento: [],
            completeauditList: {},
            tipoOptionList: {},
            coddis: '',
            codcon: '',
            codfrg: '',
            postcode: '',
            atividades: props.data.atividades || [],
            entreposto: props.data.entreposto || [],
            checkbox: props.data.checkbox || [],
            entrepostoList: '',
            tableState: 'Instalações_Vasilhas',
            posterrormessage: false,
            mandatoryFieldsMissing: {
                "designacaoSocial": true, //
                //"numeroEntrepostoFiscal": true, //
                //"codigoPostalExtenso": true,
                "codigoPostal": true,
                "coddis": true,
                "codcon": true,
                "codfrg": true,
                "morada": true,
                "idEntreposto": true,
                "idAtividade": true,
                "codigoIVV": true,
                "codEntrFiscal": true,
                "Etar": true,
                "LicenciamentoIndustrial": true

            },

        }

    }


    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidUpdate(preProps, preState) {
        //console.log("800 in update",preProps.date)
        if (preProps.date !== this.props.date) {
            this.setState({
                data: this.props.ivvFormData,
                ivvData: this.props.ivvFormData,
            }, () => {
                // this.sliceCodigo(this.state.ivvData);
                this.getAllTipo();
            })
            console.log("123456789", this.state.ivvData)
        }
        // if(Object.keys(this.props.ivvFormData).length!==0){
        //     console.log("update is working")
        //     this.setState({
        //         data: this.props.ivvFormData,
        //         ivvData: this.props.ivvFormData,
        //     })
        // }
    }

    componentDidMount() {
        (async () => {
            //Drop Tipo de Instalação
            const dataTipoInstalacao = {}
            const GetAllTipoInstalacao = await services.apiCall.requestApi(
                "InstalacaoVinica/GetTipoInstalacao",
                dataTipoInstalacao,
                "get"
            );

            console.log("**** Teste ***** Tipo de Instalação: ", GetAllTipoInstalacao)


            //$("#idAtive").html(strHTML1);           
            await this.getTiposAtividadeIVV();
            const queryParams = queryString.parse(window.location.search)
            const cenas = queryParams.idInstalacao
            if (cenas != undefined) {
                const data = { "idInstalacaoVinica": cenas }
                const GetAllDataField = await services.apiCall.requestApi(
                    "InstalacaoVinica/ViewInstalacaoVinicaDetalhe",
                    data,
                    "get"
                );
                console.log("GETALLFIELD: ", GetAllDataField)
                const IVTipoInstalacao = {}
                const GetIVTI = await services.apiCall.requestApi(
                    `/InstalacaoVinica/GetIVTI/${encodeURIComponent(GetAllDataField.idInstalacaoVinica)}`,
                    IVTipoInstalacao,
                    "get"
                )

                console.log("ATIVIDADES DO GETALLDATAFIELD:", GetAllDataField.atividade);

                const atividadesIVVCodes = (GetAllDataField.atividade || [])
                    .map(atividade => Number(atividade.codAtividade))
                    .filter(codigo => Number.isFinite(codigo));

                console.log("CÓDIGOS IVV PARA O SELECT:", atividadesIVVCodes);

                this.setState({
                    atividades: atividadesIVVCodes,
                    ivvData: {
                        ...this.state.ivvData,
                        atividades: atividadesIVVCodes,
                        idAtive: atividadesIVVCodes
                    }
                }, () => {
                    console.log("✅ ATIVIDADES STATE:", this.state.atividades);
                    console.log("✅ IVVDATA:", this.state.ivvData);

                    this.props.getcenterformdata(this.state.ivvData);
                });


                //tiposInstalacao.push(GetIVTI);
                //atividades.push(GetIVA);
                console.log("tiposInstalacao: ", tiposInstalacao)
                console.log("atividades: ", atividades)
                // this.setState({ArrayDataFields: data})   
                ArrayDataFields.push(GetAllDataField);
                this.setState({
                    ArrayDataFields: [...ArrayDataFields],
                    ivvData: {
                        ...this.state.ivvData,
                        geocodigo: GetAllDataField.geocodigo
                    }
                });
                arrayTipoInstalacao.push(GetAllTipoInstalacao);
                console.log("É ISTO AQUI -------------------------------->", ArrayDataFields, GetAllDataField)
                console.log("Local Armazenagem: ", ArrayDataFields[0].localArmazenagem)
                if (ArrayDataFields[0] != undefined) {
                    const delay = ms => new Promise(res => setTimeout(res, ms));
                    await delay(2000)
                    firstTime = true
                    countLocationTimes = 0
                    this.sliceCodigo(GetAllDataField)
                    this.getLocationData("distrito_id", this.coddis)
                    this.getLocationData("country_id", this.codcon)
                    this.getLocationData("fregusia_id", this.codfrg)
                    this.tipoInstalacaoSelect(tiposInstalacao)

                    this.changeEstadoToNumber()
                    this.createCheckbox()
                }
                if (ArrayDataFields.length > 0) {
                    for (let index = 0; index < ArrayDataFields.length; index++) {
                        var instalacaoVinica = ArrayDataFields[index].instalacaoVinica;
                        $("#idDesignacao").val(instalacaoVinica)
                        $("#idDesignacao").text(instalacaoVinica)
                        var idcodEntrFiscal = ArrayDataFields[index].codEntrFiscal;
                        $("#idcodEntrFiscal").val(idcodEntrFiscal)
                        var codIVV = ArrayDataFields[index].codigoIVV;
                        $("#idCodIVV").val(codIVV)
                        var areaCoberta = ArrayDataFields[index].areaCoberta;
                        $("#areaCoberta").val(areaCoberta)
                        var numeroLicIndustrial = ArrayDataFields[index].numeroLicIndustrial;
                        $("#numeroLicIndustrial").val(numeroLicIndustrial)
                        // var localArmazenagem = ArrayDataFields[index].localArmazenagem;
                        // $("#localArmazenagem").val(localArmazenagem)
                    }
                    $(".k-textbox-container").removeClass("k-state-empty")
                }

            } else {
                const dataAtividades = {}
                const GetAllAtividades2 = await services.apiCall.requestApi(
                    "InstalacaoVinica/GetAllAtividades",
                    dataAtividades,
                    "get"
                );

                arrayAtividade.push(GetAllAtividades2);

                const query = window.location.search.substring(1);
                const params = query.split('&');
                let queryParams = {};
                if (params) {
                    params.forEach(function (param) {
                        let [key, value] = param.split('=');
                        key = decodeURIComponent(key);
                        value = decodeURIComponent(value || '');  // Tratar valores não definidos
                        queryParams[key] = value;
                    });

                    ArrayDataFields.push(queryParams);

                    if (ArrayDataFields[0] != undefined) {
                        const delay = ms => new Promise(res => setTimeout(res, ms));
                        await delay(2000)
                        firstTime = true
                        countLocationTimes = 0
                        if (ArrayDataFields[0].codigoPostal) {
                            this.sliceCodigo(ArrayDataFields[0].codigoPostal.replace("-", ""))
                        }

                        this.getLocationData("distrito_id", ArrayDataFields[0].coddis)
                        this.getLocationData("country_id", ArrayDataFields[0].codcon)

                        // this.tipoInstalacaoSelect(tiposInstalacao)
                        // const atividadesArray =
                        //     ArrayDataFields[0].atividades
                        //         ? ArrayDataFields[0].atividades
                        //             .split(',')
                        //             .map(value => String(value))
                        //         : [];

                        // console.log(
                        //     "ATIVIDADES IVV PARA SELECT:",
                        //     atividadesArray
                        // );

                        // this.atividadesSelect(atividadesArray);
                        const atividadesArray =
                            ArrayDataFields[0].atividades
                                ? ArrayDataFields[0].atividades
                                    .split(',')
                                    .map(Number)
                                : [];

                        const atividadesIVVCodes =
                            ArrayDataFields[0].atividades
                                ? ArrayDataFields[0].atividades
                                    .split(',')
                                    .map(value => Number(value.trim()))
                                    .filter(value => Number.isFinite(value))
                                : [];

                        console.log("ATIVIDADES VINDAS DO IVV:", atividadesIVVCodes);

                        this.atividadesSelect(atividadesIVVCodes);
                        this.changeEstadoToNumber()
                        this.createCheckbox()

                        var instalacaoVinica = ArrayDataFields[0].designacaoSocial;
                        $("#idDesignacao").val(instalacaoVinica)
                        $("#idDesignacao").text(instalacaoVinica)
                        var idcodEntrFiscal = ArrayDataFields[0].codEntrFiscal;
                        $("#idcodEntrFiscal").val(idcodEntrFiscal)
                        var codIVV = ArrayDataFields[0].codigoIVV;
                        $("#idCodIVV").val(codIVV)
                        // var areaCoberta = ArrayDataFields[0].areaCoberta;
                        // $("#areaCoberta").val(areaCoberta)
                        var numeroLicIndustrial = ArrayDataFields[0].licenciamentoIndustrial;
                        $("#numeroLicIndustrial").val(numeroLicIndustrial)
                        // var localArmazenagem = ArrayDataFields[0].localArmazenagem;
                        // $("#localArmazenagem").val(localArmazenagem)
                        $(".k-textbox-container").removeClass("k-state-empty")

                        this.getLocationData("fregusia_id", ArrayDataFields[0].codfrg ? parseInt(ArrayDataFields[0].codfrg) < 10 ? ArrayDataFields[0].codfrg.replace("0", "") : ArrayDataFields[0].codfrg : "")
                    }

                }


            }
            this.setState({
                arrayTipoInstalacao,
                arrayAtividade,
                tiposInstalacao,
                ArrayDataFields,
                data: this.props.ivvFormData,
                ivvData: this.props.ivvFormData,
            }, () => {
                this.sliceCodigo(this.state.ivvData);
                this.getAllTipo();
            })
        })();

        //console.log("00011 mount worked", this.props.ivvFormData)

        //console.log("wizardform", this.props.ivvFormData)

    }

    changeEstadoToNumber = () => {
        var num = 0;
        if (this.state.ivvData.estado === "Ativo") {
            num = 1
        }
        else if (this.state.ivvData.estado === "Inativo") {
            num = 2
        }
        if (num > 0) {
            let ivvData = { ...this.state.ivvData, ["estado"]: num }
            this.setState({
                estado: num,
                ivvData
            }, () => {
                this.props.getcenterformdata(ivvData)
            })
            console.log("134567", this.state.ivvData.estado)
        }

    }

    handleCheck = (e) => {
        let { requiredField } = { ...this.state };
        if (e.target.checked) requiredField["AssignGroup"] = false;
        else delete requiredField["AssignGroup"];
        if (this.state.id) {
            this.setgroupRemovePopup();
        }

        this.setState(
            {
                isGroupAssign: e.target.checked,
                requiredField,
            },
            () => {
                let { isGroupAssign, showPopup } = this.state;
                if (isGroupAssign) {
                    showPopup = false;
                } else {
                    showPopup = true;
                }
                this.setState({
                    showPopup,
                });
            }
        );
    };

    getTipoInstalacao = () => {
        if (arrayTipoInstalacao[0] != undefined && arrayTipoInstalacao[0] != null) {
            const res = []
            if (arrayTipoInstalacao[0]) {
                let { tiposInstalacao, tiposInstalacaoNome } = this.state;
                tiposInstalacao.map((id) => {
                    arrayTipoInstalacao[0].map((tipo) => {
                        if (tipo.idTipoInstalacao === id) {
                            tiposInstalacao = [...tiposInstalacaoNome, tipo.descricao];
                        }
                    });
                });
                console.log("TESTE TIPO: ", tiposInstalacao)
                console.log("TESTE TIPO NOME: ", tiposInstalacaoNome)
                tiposInstalacao.map((tipo) => {
                    res.push(tipo.idTipoInstalacao)
                })
                console.log("RES TIP: ", res);
                if (res == undefined || res == null) {
                    return [];
                }
                return res;
            }
        }
        return []
    }

    getAtividades = () => {
        if (arrayAtividade[0] != undefined && arrayAtividade[0] != null) {
            const res = []
            if (arrayAtividade[0]) {
                let { atividades, atividadesNome } = this.state;
                atividades.map((id) => {
                    arrayAtividade[0].map((atividade) => {
                        if (atividade.idAtividade === id) {
                            atividades = [...atividadesNome, atividade.descricaoAtividade];
                        }
                    });
                });
                console.log("TESTE Ativ: ", atividades)
                console.log("TESTE Ativ NOME: ", atividadesNome)
                atividades.map((ativ) => {
                    res.push(ativ.idAtividade)
                })
                console.log("RES ACT: ", res)
                if (res == undefined || res == null) {
                    return [];
                }
                return res;
            }
        }
        return []
    }

    sliceCodigo = (value) => {
        //console.log("00011 in", value)
        let key = this.props.ivvFormData && this.props.ivvFormData.freguesiaCodigo || ''
        //console.log("key in the component",key)
        if (value.dicofre != undefined) {
            //console.log("valueeeeeee", ArrayDataFields[0].dicofre)
            let coddis = parseInt(value.dicofre.substring(0, 2))
            let codcon = parseInt(value.dicofre.substring(2, 4))
            let codfrg = parseInt(value.dicofre.substring(4, 6))
            coddis = String(coddis)
            codcon = String(codcon)
            codfrg = String(codfrg)
            this.coddis = String(coddis)
            this.codcon = String(codcon)
            this.codfrg = String(codfrg)

            this.setState({
                coddis,
                codcon,
                codfrg
            }, () => {
                console.log("2010 initial ", this.state.coddis)
                console.log("Estou aqui********: ", this.state.ArrayDataFields)
            })
        }
        else {
            return
        }

    }

    entrepostoSearch = async (value) => {
        //console.log("6677 hello search")
        //https://localhost:44397/api/InstalacaoVinica/GetEntrepostoList
        let link = "InstalacaoVinica/GetEntrepostoList"
        let request = {
            Filters: null,
            SortBy: '',
            IsSortTypeDESC: true,
            IsPagination: false,
            Page: 2,
            PageSize: 2,
            isConta: 0
        }
        let res
        if (value.length) {
            if (isNaN(value)) {
                request["searchKey"] = value
                request["search"] = ""
            }
            else {
                request["searchKey"] = ""
                request["search"] = value
            }
            res = await services.apiCall.requestApi(link, request, "post")
        }
        if (res) {
            //console.log("the entreposto list 55566 pehle", res)
            const entrepostoList = res.map((entreposto, index) => (
                <Option key={index} value={entreposto.idInstalacaoVinica}>{entreposto.idInstalacaoVinica} <br /> {entreposto.designacao.toString().trim()} - {entreposto.codEntrFiscal}</Option>
            ))
            this.setState({
                entrepostoList
            }, () => {
                //console.log("the entrepostoList 55566 after", this.state.entrepostoList)
            })
            // this.setState({ 
            // installationOptions
            //}, () => {
            //     console.log("installation options ", this.state.installationOptions)
            //   })
        }
        else {
            this.setState({
                entrepostoList: []
            })
        }
    }

    entrepostoSelect = (value) => {
        //console.log("6677 alert onChange")
        this.setState({
            entreposto: value
        })
    }

    tipoCheckboxSelect = (value) => {
        let checkbox
        if (value.length > 0) checkbox = value
        else checkbox = []
        let ivvData = { ...this.state.ivvData, ["checkbox"]: value }
        this.setState({
            checkbox,
            ivvData
        }, () => {
            //this.sendAtividadesToMainForm()
            this.props.getcenterformdata(ivvData)

        })
    }

    atividadesSelect = (value) => {
        console.log("🚨 atividadesSelect:", value);

        const atividadesSelecionadas = (value || []).map(Number);

        const ivvData = {
            ...this.state.ivvData,
            atividades: atividadesSelecionadas,
            idAtive: atividadesSelecionadas
        };

        atividades = atividadesSelecionadas;

        this.setState(
            {
                atividades: atividadesSelecionadas,
                ivvData: ivvData
            },
            () => {
                console.log("✅ State atividades:", this.state.atividades);
                console.log("✅ ivvData:", this.state.ivvData);

                this.props.getcenterformdata(ivvData);
            }
        );
    };

    tipoInstalacaoSelect = (value) => {
        let ivvData = { ...this.state.ivvData, ["tiposInstalacao"]: value }
        tiposInstalacao = value
        this.setState({
            tiposInstalacao: value,
            ivvData
        }, () => {
            this.props.getcenterformdata(ivvData)
        })
        console.log("12345", this.state.ivvData)
    }


    entrepostoSelect = (value) => {
        let entreposto
        if (value.length > 0) entreposto = value
        else entreposto = []
        let ivvData = { ...this.state.ivvData, ["entreposto"]: value }
        this.setState({
            entreposto,
            ivvData
        }, () => {
            //this.sendAtividadesToMainForm()
            this.props.getcenterformdata(ivvData)

        })
        console.log(this.state.ivvData)
    }

    sendAtividadesToMainForm = () => {
        let ivvData = { ...this.state.ivvData }
        ivvData["idAtividade"] = this.state.atividades
        this.setState({
            ivvData
        }, () => {
            this.props.getcenterformdata(ivvData)
        })
        console.log(this.state.ivvData)
    }

    numberWithCommas = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    getAllTipo = async () => {
        let res = await services.apiCall.requestApi("/allservice/TipoVasilha/GetAll", combolistrequest, "post")

        //console.log("Tipores",res)
        this.setState({ tipoOptionList: res })

    }
    componentDidUpdate(preprop) {
        if (preprop.date !== this.props.date) {
            //console.log("updateeeeeeee done")

            this.setState({
                data: this.props.data,
                //data: this.props.ivvFormData,
                ivvData: this.props.ivvFormData,
            }, () => {
                //this.sliceCodigo();
            })
            console.log(this.state.ivvData)
        }

        if (preprop.ivvFormData.freguesiaCodigo !== this.props.freguesiaCodigo && preprop.ivvFormData.freguesiaCodigo == undefined) {
            this.setState({
                data: this.props.data,
                //data: this.props.ivvFormData,
                ivvData: this.props.ivvFormData,
            })
            console.log(this.state.ivvData)
        }
    }

    formatInput = (e) => {
        e.persist()
        //console.log("format input", e)
        let checkIfNum;
        if (e.key !== undefined) {
            checkIfNum = e.key === "e" || e.key === "+" || e.key === "-" || e.key === "E";
        }
        else if (e.keyCode !== undefined) {
            checkIfNum = e.keyCode === 69 || e.keyCode === 187 || e.keyCode === 189;
        }
        return checkIfNum && e.preventDefault();
    }

    createOthersTables = (modulename) => {
        let data = { ...this.state.data }
        let langkey = ""
        if (data) {
            let module = data[modulename];

            if (module) {
                if (!Array.isArray(module)) {
                    if (Object.keys(module).length === 0)
                        return
                    module = [module]
                }
                let telericdata = [];
                let telerikRow = {};
                module.map((_row, index) => (
                    telerikRow = {},
                    Object.keys(_row).map(function (key) {
                        if (key === 'time') {
                            _row[key] = moment(_row.date).format('LTS')
                        } else if (key === 'date') {
                            _row[key] = moment(_row.date).format('DD-MM-YYYY')
                        }
                        langkey = Lang.langCheck.langRequest(key);
                        telerikRow[langkey] = _row[key]
                    }),
                    telericdata.push(telerikRow)
                ));
                this.telrikTable(telericdata, modulename)
            }
        }
    }

    makerowForTable = (_r) => {
        let row = {}
        Object.keys(_r).map((key) => {
            if (key === "iddtplantacao" || key === "iddtorigem" || key === "tipo" || key === "areaapdouro" || key === "areaapporto" || key === "obs" || key === "predioarranque")
                row[Lang.langCheck.langRequest(key)] = _r[key]
        });
        return row;
    }

    createCheckbox = () => {

        let data = { ...this.state.ivvData };

        data["checkbox"] = data["checkbox"]
            ? { ...data["checkbox"] }
            : {};

        // ==========================================
        // LICENCIAMENTO INDUSTRIAL
        // ==========================================

        if (
            data["checkbox"]["LicenciamentoIndustrial"] === true ||
            data["licenciamentoIndustrial"] === true ||
            data["semLicenciamentoIndustrial"] === "false" ||
            data["LicenciamentoIndustrial"] === "true"
        ) {
            data["checkbox"]["LicenciamentoIndustrial"] = 1;
        } else {
            data["checkbox"]["LicenciamentoIndustrial"] = 0;
        }


        // ==========================================
        // ETAR
        // ==========================================

        if (this.state.ivvData.etar === true) {
            data["checkbox"]["Etar"] = 1;
        }
        else {
            data["checkbox"]["Etar"] = 0;
        }


        this.setState({
            ivvData: data
        }, () => {
            this.props.getcenterformdata(this.state.ivvData);
        });

    }

    handleCheck = (e, modulename) => {
        if (this.props.isEnable(e.target.name)) {
            return
        }
        let data = { ...this.state.ivvData };
        // data[modulename] = data[modulename] ? data[modulename] : {}
        // let module = data[modulename];
        data[modulename] = data[modulename] ? data[modulename] : {}
        let key = e.target.name;
        let value = data[modulename][key] ? 0 : 1;
        data[modulename][key] = value;
        // console.log(";;;;;;;;;;;;;;;;;;;;;;;inside else inner", data)

        if (key === "LicenciamentoIndustrial") {
            data.NumeroLicIndustrial = ""
            if (data[modulename]["Etar"] === undefined) {
                if (this.state.ivvData.etar === true) {
                    data[modulename]["Etar"] = 1
                }
                else {
                    data[modulename]["Etar"] = 0
                }
            }
        }

        if (key === "Etar") {
            if (data[modulename]["LicenciamentoIndustrial"] === undefined) {
                if (this.state.ivvData.licenciamentoIndustrial === true) {
                    data[modulename]["LicenciamentoIndustrial"] = 1
                }
                else {
                    data[modulename]["LicenciamentoIndustrial"] = 0
                }
            }
        }



        //console.log("dataaaaaa", data)
        this.setState({
            ivvData: data
        }, () => {
            //console.log("the new ivvData is....", this.state.ivvData)
            this.props.getcenterformdata(this.state.ivvData)
            //console.log("dataaaaaa after func", this.state.ivvData)

        })
        console.log(this.state.ivvData)
        return true;
    }

    telrikTable = (data, modulename) => {
        let columnkeyMap = {}
        if (data.length > 0) {
            Object.keys(data[0]).map((_k) => {
                if (modulename === 'matrixArticle') {
                    if ((_k === 'Fração' || _k === 'Nº Artigo')) {
                        columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
                    }
                } else {
                    columnkeyMap[_k] = Lang.langCheck.langRequest(_k)
                }
            })
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
            });
            data.map((row, index) => {
                row.index = index
                row.modulename = modulename
            })
            let actionbuttons = { Delete: true }
            if (modulename === 'audit') {
                actionbuttons = { Popup: true }
            }

            let telkikTable = this.state.telkikTable
            telkikTable[modulename] = <Main date={new Date()} list={data} actionbuttons={actionbuttons} columnlist={columnlist} deleteFunc={(id) => this.deleteFunc(id)} ActionPerform={(action, id) => this.ActionPerform(action, id)} />
            this.setState({
                telkikTable: telkikTable
            })
        }
    }

    setStateDate = () => {
        let date = new Date()
        this.setState({
            date
        })
    }

    deleteFunc = (_row) => {
        //console.log("to delete:", _row);
        let data = { ...this.state.data };

        data[_row.modulename].splice(_row.index, 1);
        let telkikTable = { ...this.state.telkikTable }
        telkikTable[_row.modulename] = null;
        if (_row.modulename === "castaparc") {
            data = this.updatecastaForm(data[_row.modulename], data)
        }
        this.props.getcenterformdata(data)
        this.setState({
            data,
            telkikTable
        }, () => this.createOthersTables(_row.modulename))
        return true;
    }

    setcompleteAuditlist = async (data) => {
        let completeauditList = {}
        let Auditdata = await services.apiCall.requestApi('/auditlog/getall', data, 'post');
        // if(Auditdata){
        //   Auditdata.map((_row, index) => {
        //       completeauditList[parseInt(_row.id)]=_row
        //   })
        // }
        this.setState({
            completeauditList: Auditdata
        })
    }

    showRowDeatils = (row) => {
        let completeauditList = { ...this.state.completeauditList }
        let detailPopUp = (
            <RowDeatils date={new Date()} record={completeauditList[row.index] || {}} />
        )
        this.setState({
            detailPopUp: detailPopUp
        })
    }

    ActionPerform = (action, row) => {
        if (action === "vasilhaEdit") {

            this.openInserirvasilha(row)
        }

        else if (action === "vasilhaRemove") {
            this.removeVasilha(row)
        }
        //this.showRowDeatils(row);
    }

    removeVasilha = async (row) => {
        let link = "InstalacaoVinica/DeleteVasilha"
        let request = {
            idVasilha: row.idVasilha
        }
        let res = await services.apiCall.requestApi(link, request, "post")
        if (res) {
            await this.props.getAllVasilha()
            this.setStateDate()

            this.setState()

            //toast.success("Vasilha removida com sucesso da instalação viníca!")
        }
        else {
            toast.error("Não foi possível adicionar o navio!")
        }
    }

    calculator = () => {
        let detailPopUp = (
            <Calculator />
        )
        this.setState({
            detailPopUp
        })
    }

    /* to open vasilha form popup */
    openInserirvasilha = (row) => {

        this.setState({
            detailPopUp: null
        })

        let detailPopUp = (
            <Inserirvasilha
                date={new Date()}
                VasilhaData={(data) => this.VasilhaData(data)}
                IDInstalacaoVinica={this.props.idInstalacaoVinica}
                tipoOptionList={this.state.tipoOptionList}
                displayData={this.props.displayData}
                getNifArray={(data) => this.props.getNifArray(data)}
                closePopup={() => this.props.closePopup()}
                row={row}
                getAllVasilha={() => this.props.getAllVasilha()}
                setStateDate={() => this.setStateDate()}
            />
        )
        this.setState({
            detailPopUp
        })

    }

    VasilhaData = (data) => {
        this.setState({
            VasilhaData: data,
        }, () => this.props.getVasilhaData(data))
    }

    handleChange = (e) => {
        let data = { ...this.state.data }
        data[e.target.name] = e.target.value
        this.setState({
            data
        })
    }

    handleChangeIVVForm = (e, type) => {

        let name = e.target.name;
        let keyCode = e.nativeEvent.data
        let checkvalue = e.target.value;
        var regex = /^[0-9]{4}-[0-9]{3}$/
        let { postcode } = this.state;
        let { posterrormessage } = this.state;
        // console.log("checkvalue", checkvalue)
        let mandatoryArray = Object.keys(this.state.mandatoryFieldsMissing)
        let mandatoryFieldsMissing = { ...this.state.mandatoryFieldsMissing }

        if (type === 'formData') {
            let { ivvData } = { ...this.state }
            // ivvData[e.target.name] = checkvalue
            if (name == textDigitOnly[4]) {

                if (checkvalue == "") {
                    ivvData[name] = "";
                }
                if (checkvalue.length <= 8) {
                    postcode = checkvalue;
                    this.setState({
                        postcode,
                    })

                }
                if (regex.test(postcode)) {
                    ivvData[name] = postcode;
                    posterrormessage = false;
                }
                if (!regex.test(postcode)) {
                    posterrormessage = true;
                }
                this.setState({ posterrormessage })
                // if(regex.test(postcode.toString)){
                //     console.log("postcode if block",postcode)
                //     ivvData[name]=checkvalue;
                // }
            }

            if (name == textDigitOnly[2] || name === textDigitOnly[3]) {

                if (keyCode != null && ((keyCode.charCodeAt(0) >= 65 && keyCode.charCodeAt(0) <= 90) || (keyCode.charCodeAt(0) >= 97 && keyCode.charCodeAt(0) <= 122) || keyCode == " ")) {
                    ivvData[e.target.name] = checkvalue
                }
                else {
                    ivvData[e.target.name] = checkvalue.length ? checkvalue.substring(0, checkvalue.length - 1) : ""
                }
            }

            if (name == textDigitOnly[0]) {
                //console.log("change", e)                
                if (!isNaN(checkvalue)) {
                    if (checkvalue.length <= 14) {
                        ivvData[e.target.name] = checkvalue
                        ArrayDataFields[0].geocodigo = checkvalue
                    }
                    else {
                        return
                    }
                }
                else {
                    return
                    // ivvData[e.target.name] = checkvalue.length?checkvalue.substring(0,checkvalue.length-1):""
                }
            }

            //AreaCobarata Decimal 
            if (name == textDigitOnly[1]) {

                if (isNaN(keyCode) == false || keyCode == ".") {

                    let decimalsep = checkvalue.indexOf(".")

                    if (decimalsep == 0) {
                        ivvData[name] = ""
                        ArrayDataFields[0].areaCoberta = ""
                    }
                    else if (decimalsep >= 1 && checkvalue.length <= 12) {
                        let countdec = (checkvalue.length - 1 - decimalsep)
                        ivvData[name] = checkvalue;
                        ArrayDataFields[0].areaCoberta = checkvalue

                    }
                    else if (decimalsep == -1 && checkvalue.length <= 12) {
                        ivvData[name] = checkvalue;
                        ArrayDataFields[0].areaCoberta = checkvalue
                    }
                    else if (checkvalue.length > 12) {
                        return
                    }
                }

            }
            if (name == textDigitOnly[3]) {
                ArrayDataFields[0].lugar = checkvalue
            }

            if (name === 'telefone' || name === 'fax' || name === "licenceIndustrial") {
                let regex = /^\d{0,9}$/
                if (name === "licenceIndustrial")
                    regex = /^\d+$/
                if (regex.test(checkvalue)) {
                    ivvData[e.target.name] = checkvalue
                }
            }

            if (name === 'designacaoSocial') {
                ivvData[e.target.name] = checkvalue
            }
            if (name === 'observacoes') {
                ivvData[e.target.name] = checkvalue
            }
            if (name === 'codEntrFiscal') {
                ivvData[e.target.name] = checkvalue
                if (ArrayDataFields[0]) {
                    ArrayDataFields[0].codEntrFiscal = checkvalue
                }

            }
            if (name === 'codigoIVV') {
                ivvData[e.target.name] = checkvalue
                if (ArrayDataFields[0]) {
                    ArrayDataFields[0].codigoIVV = checkvalue
                }

            }
            // if(name === 'numeroEntrepostoFiscal') {
            //     ivvData[e.target.name] = checkvalue
            // }
            if (name === 'numeroLicIndustrial') {
                ivvData[e.target.name] = checkvalue
            }
            if (name === 'idAtividade') {
                ivvData[e.target.name] = parseInt(checkvalue)
            }
            if (name === 'estado') {
                ivvData[e.target.name] = parseInt(checkvalue)
            }
            if (name === 'localArmazenagem') {
                console.log("Name: ", name);
                console.log("IVVDATA target before: ", ivvData[e.target.name])
                ivvData[e.target.name] = checkvalue
                console.log("IVVDATA target after: ", ivvData[e.target.name])
            }
            if (name === "idEntreposto") {
                ivvData[e.target.name] = parseInt(checkvalue)
            }
            if (name === "Etar") {
                ivvData[e.target.name] = parseInt(checkvalue)
            }
            if (name === "LicenciamentoIndustrial") {
                ivvData[e.target.name] = parseInt(checkvalue)
            }
            if (mandatoryArray.includes(e.target.name)) {
                // console.log("worked now")
                let set = null
                if (e.target.value == "") set = true
                else set = false
                mandatoryFieldsMissing = { ...this.state.mandatoryFieldsMissing, [e.target.name]: set }
            }
            this.setState({
                ivvData,
                mandatoryFieldsMissing
            }, () => {
                this.props.getcenterformdata(ivvData)
            })
            console.log(this.state.ivvData)

        }

    }

    getLocationData = (key, value) => {
        //console.log("2010 key and value ", key, value)
        var Distrito = ArrayDataFields
        let { codcon, coddis, codfrg } = { ...this.state };
        if (firstTime === true && countLocationTimes < 3) {
            if (key === 'distrito_id') {
                coddis = value;
                this.coddis = value;
            }
            else if (key === 'country_id') {
                codcon = value;
                this.codcon = value;
            }
            else if (key === 'fregusia_id') {
                codfrg = value;
                this.codfrg = value;
            }
            countLocationTimes++;
            if (countLocationTimes >= 3) {
                firstTime = false;
            }
        }
        else {
            if (key === 'distrito_id') {
                coddis = value;
                codcon = "";
                codfrg = "";
                this.coddis = value;
                this.codcon = "";
                this.codfrg = "";
            }
            else if (key === 'country_id') {
                codcon = value;
                codfrg = "";
                this.codcon = value;
                this.codfrg = "";
            }
            else if (key === 'fregusia_id') {
                codfrg = value;
                this.codfrg = value;
            }
        }
        this.setState({
            coddis,
            codcon,
            codfrg
        }, () => {
            this.props.getcenterformdata({
                coddis,
                codcon,
                codfrg
            })
        })
    }

    //   fourthcol=()=>{
    //     return(
    //         <div className="col-md-3">
    //         <div className="input-box active-grey drop-down-box">
    //             <label className="input-label">Entreposto </label>
    //             <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='codfrg' value={this.state.ivvData.dicofre || ''} >
    //                 <option>Selecione Entreposto </option>
    //                 {
    //                     this.props.all_list.EntrepostoDropdown &&
    //                     this.props.all_list.EntrepostoDropdown.map((_row, index) => (
    //                         <option value={_row.idEntreposto}>{_row.nomeEntreposto}</option>
    //                     ))
    //                 }
    //             </select>
    //         </div>
    //         </div>
    //     )
    //   }

    forceRender = () => {
        this.forceUpdate()
    }

    getTiposAtividadeIVV = async () => {
        try {
            const response = await services.apiCall.requestApi(
                "InstalacaoVinica/GetTiposAtividadeIVV",
                {},
                "get"
            );

            console.log("TIPOS ATIVIDADE IVV:", response);

            if (Array.isArray(response)) {
                this.setState({
                    tiposAtividadeIVV: response
                });
            } else {
                console.error(
                    "Resposta inválida do GetTiposAtividadeIVV:",
                    response
                );

                this.setState({
                    tiposAtividadeIVV: []
                });
            }

        } catch (error) {
            console.error(
                "Erro ao chamar GetTiposAtividadeIVV:",
                error
            );

            this.setState({
                tiposAtividadeIVV: []
            });
        }
    }

    /*  para renderizar o conteúdo html da página   */

    render() {

        console.log("TESTE ARRAY", ArrayDataFields[0])
        console.log("TESTESSSSS", arrayAtividade)
        console.log("00011 render", this.props.ivvFormData)
        console.log("Render", this.state.ivvData)
        const queryParams = queryString.parse(window.location.search)
        var vascodEntidade = +queryParams.codEntidade
        let renderfour = ""
        return (
            <div className="right-section">
                <div className="bg-white middle p20" id="Dadosgerais">
                    <form className="parcelforms" rel={'parcel'} data={-1}>
                        <div className="head">
                            <h2>Dados gerais</h2>
                            {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="input-box active-grey">
                                    <label className="input-label">Designação</label>
                                    <textarea
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        className="form-control heigh-auto" rows="1"
                                        readOnly={this.props.isEnable("designacaoSocial")}
                                        name="designacaoSocial"
                                        id='idDesignacao'
                                    //value={ArrayDataFields[0].designacao}
                                    />
                                </div>
                                {
                                    this.props.checkMandatoryFields && !this.state.ivvData.designacaoSocial &&
                                    <span className="text-danger" style={{ marginTop: "-10px" }}>Campo obrigatório</span>
                                }
                            </div>

                            <div className="col-md-3">
                                {/* <div className="input-box active-grey"> */}
                                {ArrayDataFields[0] != undefined ?
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="codEntrFiscal"
                                            id='idcodEntrFiscal'
                                            value={ArrayDataFields[0].codEntrFiscal}
                                            readOnly={this.props.isEnable("codEntrFiscal")}
                                            label="Código entreposto fiscal"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        />
                                        {
                                            this.props.checkMandatoryFields && !this.state.ivvData.codEntrFiscal &&
                                            <span className="text-danger" style={{ marginTop: "-10px" }}>Campo obrigatório</span>
                                        }
                                    </div>
                                    :
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="codEntrFiscal"
                                            id='idcodEntrFiscal'
                                            readOnly={this.props.isEnable("codEntrFiscal")}
                                            label="Código entreposto fiscal"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        />
                                        {
                                            this.props.checkMandatoryFields && !this.state.ivvData.codEntrFiscal &&
                                            <span className="text-danger" style={{ marginTop: "-10px" }}>Campo obrigatório</span>
                                        }
                                    </div>
                                }
                            </div>
                            {/*codigoIVV input ---------------------------------*/}
                            <div className="col-md-3">
                                {/* <div className="input-box active-grey"> */}
                                {ArrayDataFields[0] != undefined ?
                                    <div className="input-box active-grey">
                                        <Input
                                            //type="number"
                                            //maxLength={14}
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="codigoIVV"
                                            id='idCodIVV'
                                            value={ArrayDataFields[0].codigoIVV}
                                            readOnly={this.props.isEnable("codigoIVV")}
                                            label="Código IVV"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                            disabled
                                        />
                                    </div>
                                    :
                                    <div className="input-box active-grey">
                                        <Input
                                            //type="number"
                                            //maxLength={14}
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="codigoIVV"
                                            id='idCodIVV'
                                            readOnly={this.props.isEnable("codigoIVV")}
                                            label="Código IVV"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                            disabled
                                        />
                                    </div>
                                }
                                {/* {ArrayDataFields[0] != undefined ?

                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="id"
                                        disabled
                                        value={ArrayDataFields[0].codigoIVV}
                                        //readOnly={this.props.isEnable("id")}
                                        //readOnly={true}
                                        label="Código IVV"
                                        id='idCodIVV'
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    : 
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="id"
                                        //readOnly={this.props.isEnable("id")}
                                        //readOnly={true}
                                        label="Código IVV"
                                        id='idCodIVV'
                                        //onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    }  
                                    
                                </div> */}
                            </div>

                            {/**SIT doubt-------------------------------------- disabled for now*/}
                            <div className="col-md-3">
                                <div className="input-box active-grey">
                                    {/*
                                    <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='coddis' disabled value={this.state.ivvData.coddis || ''} >
                                        <option>Selecione Sit. IVV </option>
                                        {ArrayDataFields
                                            this.props.all_list.InstalacaoVinica &&
                                            this.props.all_list.InstalacaoVinica.map((_row, index) => (
                                                <option value={_row.idInstalacaoVinica}>{_row.instalacaoVinica}</option>
                                            ))
                                        }
                                    </select>
                                    */}
                                    {ArrayDataFields[0] != undefined ?
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="sitIVV"
                                            disabled
                                            value={
                                                this.state.ivvData.estadoCodigo ||
                                                this.state.ivvData.estado ||
                                                ''
                                            }
                                            //readOnly={this.props.isEnable("id")}
                                            //readOnly={true}
                                            label="SIT. IVV"
                                        //onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        />
                                        :
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="sitIVV"
                                            //readOnly={this.props.isEnable("id")}
                                            //readOnly={true}
                                            label="SIT. IVV"
                                        //onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        />
                                    }

                                </div>
                            </div>
                            {/**Estado doubt------------------------------------- disabled for now*/}
                            {
                                this.props.isInEdit &&
                                <div className="col-md-3">
                                    <div className="input-box active-grey drop-down-box mt1rem">
                                        <label className="input-label">Estado </label>
                                        <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='estado' value={this.state.ivvData.estado} >
                                            {
                                                console.log("1345", this.state.ivvData.estado)
                                            }
                                            {
                                                !this.props.isInEdit &&
                                                <option disabled>Selecione Estado </option>
                                            }
                                            <option disabled>Selecione Estado </option>
                                            {
                                                estadoDropdown.map((row, index) => (
                                                    <option key={index} value={row.value}>{row.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            }


                        </div>
                        {/* <div className="row mb-0">
                            <div className="col-md-12 mb-0">
                                {!this.props.isInEdit &&
                                 <center className="vinica-dados-form-alert" > 
                                    <p > 
                                    Os campos encontram-se bloqueados porque não tem código IVV (ex.:  Instalação espanhola)
                                    </p>
                                </center>}
                             </div>
                        </div> */}
                        {/**tipo start */}
                        {/* <div className="head mt-4">
                            <h2 className="vinica-subHead"> Tipo instalação</h2>
                        </div> */}


                        {/* <div className="row">
                            <div className="col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => this.handleCheck(e, 'checkbox')}
                                        className="custom-control-input" 
                                        id="customCheck"
                                        name="Vinificacao" 
                                        checked={this.state.data.checkbox ? this.state.data.checkbox.Vinificacao : ''}
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck">Vinificação</label>
                                </div>

                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => this.handleCheck(e, 'checkbox')}
                                        className="custom-control-input"
                                        id="customCheck1" name="Armazenamento"
                                        checked={this.state.data.checkbox ? this.state.data.checkbox.Armazenamento : ''}
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck1">Armazenamento</label>
                                </div>

                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        readOnly={this.props.isEnable("sitdeclar")}
                                        onChange={(e) => this.handleCheck(e, 'checkbox')}
                                        className="custom-control-input"
                                        id="customCheck2" 
                                        name="Engarrafamento"
                                        checked={this.state.data.checkbox ? this.state.data.checkbox.Engarrafamento : ''}
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck2">Engarrafamento</label>
                                </div>

                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => this.handleCheck(e, 'checkbox')}
                                        className="custom-control-input"
                                        id="customCheck3"
                                        name="ArmazenamentoProdutocabado" checked={this.state.data.checkbox ? this.state.data.checkbox.ArmazenamentoProdutocabado : ''}
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck3">Armazenamento de produto acabado</label>
                                </div>
                            </div>
                        </div> */}


                        <div className="row" style={{ alignItems: "baseline" }}>
                            <div className="col-md-4" style={{ top: "5px" }}>
                                {ArrayDataFields[0] != undefined ?
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            //type="radio"
                                            onChange={(e) => this.handleCheck(e, 'checkbox')}
                                            className="custom-control-input"
                                            id="customCheck4"
                                            value={ArrayDataFields[0].licenciamentoIndustrial}
                                            name="LicenciamentoIndustrial"
                                            //value="licIndustrial"
                                            checked={
                                                (this.state.ivvData.checkbox &&
                                                    this.state.ivvData.checkbox.LicenciamentoIndustrial === 1) ||
                                                this.state.ivvData.licenciamentoIndustrial === true ||
                                                (ArrayDataFields[0] &&
                                                    ArrayDataFields[0].licenciamentoIndustrial === true)
                                            } />
                                        <label className="custom-control-label" htmlFor="customCheck4">Lic. Industrial</label>
                                    </div>
                                    :
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            //type="radio"
                                            onChange={(e) => this.handleCheck(e, 'checkbox')}
                                            className="custom-control-input"
                                            id="customCheck4"
                                            name="LicenciamentoIndustrial"
                                            //value="licIndustrial"
                                            checked={this.state.data.checkbox ? this.state.data.checkbox.LicenciamentoIndustrial : ''} />

                                        <label className="custom-control-label" htmlFor="customCheck4">Lic. Industrial</label>
                                    </div>
                                }
                            </div>
                            {/*licenceIndustrial input ---------------------------------*/}

                            <div className="col-md-4 minus-l40-t5 mb-4">
                                {ArrayDataFields[0] != undefined ?
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="numeroLicIndustrial"
                                            value={this.state.ivvData.numeroLicIndustrial}
                                            //defaultValue={this.state.ivvData.numeroLicIndustrial || ''}
                                            readOnly={this.props.isEnable("numeroLicIndustrial")}
                                            label="Nº Licenciamento Industrial"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                            disabled={this.state.data.checkbox ? !this.state.data.checkbox.LicenciamentoIndustrial : true}
                                            id="numeroLicIndustrial"
                                        />
                                    </div>
                                    :
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="numeroLicIndustrial"
                                            readOnly={this.props.isEnable("numeroLicIndustrial")}
                                            label="Nº Licenciamento Industrial"
                                            onKeyDown={this.formatInput}
                                            onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                            //disabled={this.state.data.checkbox ? !this.state.data.checkbox.LicenciamentoIndustrial : true}
                                            id="numeroLicIndustrial"
                                        />
                                    </div>
                                }
                            </div>

                            <div className="col-md-4 " style={{ top: "5px" }}>
                                {ArrayDataFields[0] != undefined && ArrayDataFields[0].etar ?
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            //type="radio"
                                            onChange={(e) => this.handleCheck(e, 'checkbox')}
                                            className="custom-control-input"
                                            value={ArrayDataFields[0].etar}
                                            id="customCheck5"
                                            name="Etar"
                                            checked={this.state.data.checkbox ? this.state.data.checkbox.Etar : ArrayDataFields[0].etar}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck5">ETAR</label>
                                    </div>
                                    :
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            //type="radio"
                                            onChange={(e) => this.handleCheck(e, 'checkbox')}
                                            className="custom-control-input"
                                            id="customCheck5"
                                            name="Etar"
                                            checked={this.state.data.checkbox ? this.state.data.checkbox.Etar : ''}
                                        />
                                        <label className="custom-control-label" htmlFor="customCheck5">ETAR</label>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="input-box active-grey">
                                    <label className="input-label">Observações</label>
                                    <textarea
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        className="form-control heigh-auto" rows="3"
                                        readOnly={this.props.isEnable("desparc")}
                                        name="observacoes"
                                        value={this.state.ivvData.observacoes || ''}
                                    >

                                    </textarea>
                                </div>

                            </div>
                        </div>
                    </form>

                </div>
                {/**Entreposto */}
                <div className="bg-white middle p20 mt-140 position-relative">
                    <div className="head">
                        <h2 id="tipo_instalacao">Atributos IVDP</h2>
                        {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-box active-grey mt-3">
                                {
                                    console.log("State TI: ", this.state.tiposInstalacao)
                                }
                                {
                                    console.log("State ativ: ", this.state.atividades)
                                }
                                {
                                    console.log("Const TI: ", tiposInstalacao)
                                }
                                {
                                    console.log("Const ativ: ", atividades)
                                }
                                {/* <label  class="input-label" for="idTipoInst">Tipo de Instalação</label>
                                <select class="custome-drop-down" id="idTipoInst" name="idTipoInstteste">
                                    <option value="0" selected>Selecione uma opção</option>
                                    
                                </select> */}
                                <Select
                                    onChange={this.tipoInstalacaoSelect}
                                    //onSearch={this.entrepostoSearch}
                                    mode="multiple"
                                    showSearch
                                    id='idTipoInst'
                                    style={{ width: "100%" }}
                                    placeholder={"Selecionar Tipo"}
                                    value={tiposInstalacao}>
                                    {

                                        this.state.arrayTipoInstalacao[0] &&
                                        this.state.arrayTipoInstalacao[0].map((_row, index) => (
                                            <Option
                                                key={index}
                                                value={parseInt(_row.idTipoInstalacao)}>
                                                {_row.descricao.toString() && _row.descricao.trim()}
                                            </Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </div>

                    </div>
                </div>

                {/* <div className="bg-white middle p20 mt-140 position-relative">

                    <div className="head">
                        <h2 id="Entreposto">Entreposto Fiscal</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-box active-grey mt-3">
                                <Select
                                    onChange={this.entrepostoSelect}
                                    value={this.state.data.entreposto || []} 
                                    showSearch
                                    onSearch={this.entrepostoSearch}
                                    maxTagTextLength={ 3 }
                                    placeholder={"Selecionar Entreposto"}
                                    optionFilterProp="children"
                                    mode="multiple"
                                    style={{ width: "100%" }}
                                    
                                >
                                    <Option value="" disabled>Selecionar Entreposto</Option>
                                    { this.state.entrepostoList }
                                </Select>
                            </div>
                        </div>
                        
                    </div>
                </div> */}
                <div className="bg-white middle p20 mt-140 position-relative">

                    <div className="head">
                        <h2 id="Contatos">Contatos</h2>
                        {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="input-box active-grey">
                                <Input
                                    style={{ width: "100%" }}
                                    className="input-1"
                                    name="telefone"
                                    //id='telefone'
                                    value={this.state.ivvData.telefone ? this.state.ivvData.telefone.toString().trim() : ''}
                                    readOnly={this.props.isEnable("numparant")}
                                    label="Telefone"
                                    onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                <div className="bg-white middle p20 mt-140" id="link3">
                    <div className="head">
                        <h2 id="Atividades">Atividades IVV</h2>
                        {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                    </div>
                    {/* <div className="col-md-12">
                        <div className="input-box active-grey">
                            <Input
                                style={{ width: "100%" }}
                                className="input-1"
                                name="numparant"
                                value={this.state.ivvData.numparant}
                                readOnly={this.props.isEnable("numparant")}
                                label="Selecione as atividades exercidas por esta instalação"
                                onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                            />
                        </div>

                    </div> */}
                    <div className="col-md-12 pr-0 pl-0">

                        <div className="input-box active-grey drop-down-box mt1rem">
                            {
                                console.log("Atividades: ", this.state.atividades)
                            }
                            {/* <label className="input-label">Atividades</label>
                            <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='idAtividade' id="idAtive" >
                                <option selected disabled value="">Selecione as atividades exercidas por esta instalação</option>
                                {
                                    this.props.all_list.actividade &&
                                    this.props.all_list.actividade.map((_row, index) => (
                                        <option key={index} value={parseInt(_row.idAtividade)}>{_row.descricaoAtividade}</option>
                                    ))
                                }
                            </select> */}

                            <Select
                                onChange={this.atividadesSelect}
                                mode="multiple"
                                showSearch
                                id="idAtive"
                                style={{ width: "100%" }}
                                placeholder="Selecionar Atividades"
                                value={(this.state.atividades || []).map(Number)}
                            >
                                {(this.state.tiposAtividadeIVV || []).map((atividade, index) => (
                                    <Option
                                        key={Number(atividade.codigo)}
                                        value={Number(atividade.codigo)}
                                    >
                                        {atividade.descricao}
                                    </Option>
                                ))}
                            </Select>
                            {/* <label  class="input-label" for="idAtive">Atividades</label>
                                <select class="custome-drop-down" id="idAtive" name="idAtiveteste">
                                    <option value="0" selected>Selecione uma opção</option>
                                    
                                </select> */}
                            {
                                this.props.checkMandatoryFields && !this.state.ivvData.idAtividade &&
                                <span className="text-danger" style={{ marginTop: "-10px" }}>Campo obrigatório</span>
                            }
                        </div>
                    </div>
                </div>

                <div className="bg-white middle p20 mt-140" id="link3">
                    <div className="head">
                        <h2 id="Local">Local</h2>
                        {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {/*geocodigo input ---------------------------------*/}
                            {ArrayDataFields[0] != undefined ?
                                <div className="input-box active-grey">
                                    <Input
                                        type="number"
                                        maxLength={14}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="geocodigo"
                                        id='geocodigo'
                                        value={ArrayDataFields[0].geocodigo}
                                        readOnly={this.props.isEnable("geocodigo")}
                                        label="Geocódigo"
                                        onKeyDown={this.formatInput}
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                </div>
                                :
                                <div className="input-box active-grey">
                                    <Input
                                        type="number"
                                        maxLength={14}
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="geocodigo"
                                        id='geocodigo'
                                        readOnly={this.props.isEnable("geocodigo")}
                                        label="Geocódigo"
                                        onKeyDown={this.formatInput}
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                </div>
                            }

                        </div>
                        <div className="col-md-6">
                            {/*areaCoberta input ---------------------------------*/}
                            {ArrayDataFields[0] != undefined ?
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="areaCoberta"
                                        type="number"
                                        onKeyDown={this.formatInput}
                                        step="0.00000000001"
                                        value={ArrayDataFields[0].areaCoberta}
                                        readOnly={this.props.isEnable("areaCoberta")}
                                        label="Área Coberta (m2)"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        id="areaCoberta"
                                    />
                                </div>
                                :
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="areaCoberta"
                                        type="number"
                                        onKeyDown={this.formatInput}
                                        step="0.00000000001"
                                        readOnly={this.props.isEnable("areaCoberta")}
                                        label="Área Coberta (m2)"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                        id="areaCoberta"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {ArrayDataFields[0] != undefined ?
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="morada"
                                        type="text"
                                        value={this.state.ivvData.morada || ''}
                                        readOnly={this.props.isEnable("morada")}
                                        label="Morada"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    {
                                        this.props.checkMandatoryFields && !this.state.ivvData.morada &&
                                        <span className="text-danger">Campo obrigatório</span>
                                    }
                                </div>
                                :
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="morada"
                                        type="text"
                                        readOnly={this.props.isEnable("morada")}
                                        label="Morada"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    {
                                        this.props.checkMandatoryFields && !this.state.ivvData.morada &&
                                        <span className="text-danger">Campo obrigatório</span>
                                    }
                                </div>
                            }

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {/*lugar input ---------------------------------*/}

                            {ArrayDataFields[0] != undefined ?
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="lugar"
                                        type="text"
                                        value={ArrayDataFields[0].lugar}
                                        readOnly={this.props.isEnable("lugar")}
                                        label="Lugar"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                </div>
                                :
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="lugar"
                                        type="text"
                                        readOnly={this.props.isEnable("lugar")}
                                        label="Lugar"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                </div>
                            }

                        </div>
                        <div className="col-md-3">
                            {ArrayDataFields[0] != undefined ?
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        //name="codigoPostalExtenso"
                                        name="codigoPostal"
                                        value={
                                            ArrayDataFields[0].codigoPostal.replace("-", "").slice(0, 4) + " - " +
                                            ArrayDataFields[0].codigoPostal.replace("-", "").slice(4, 7)}

                                        //value={ this.state.postcode || this.state.data.codigoPostalExtenso}
                                        readOnly={this.props.isEnable("codigoPostal")}
                                        label="Código Postal"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    {this.state.posterrormessage && <><span className="text-danger">Código postal inválido (####-###)</span><br /></>}
                                    {
                                        this.props.checkMandatoryFields && !ArrayDataFields[0].codigoPostal &&
                                        <span className="text-danger">Campo obrigatório</span>
                                    }
                                </div>
                                :
                                <div className="input-box active-grey">
                                    <Input
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        //name="codigoPostalExtenso"
                                        name="codigoPostal"
                                        // value={ArrayDataFields[0] != undefined ? 
                                        //     ArrayDataFields[0].codigoPostal.slice(0, 4) + " - " + 
                                        //     ArrayDataFields[0].codigoPostal.slice(4, 7) : ""}
                                        //readOnly={this.props.isEnable("codigoPostalExtenso")}
                                        label="Código Postal"
                                        onChange={(e) => this.handleChangeIVVForm(e, 'formData')}
                                    />
                                    {this.state.posterrormessage && <><span className="text-danger">Código postal inválido (####-###)</span></>}
                                    {
                                        this.props.checkMandatoryFields && !ArrayDataFields[0].codigoPostal &&
                                        <span className="text-danger">Campo obrigatório</span>
                                    }
                                </div>
                            }

                        </div>
                        <div className="col-md-3">
                            <div className="input-box active-grey drop-down-box mt1rem">
                                <label className="input-label">Local de Armazenagem </label>
                                <select
                                    className="custome-drop-down"
                                    name="localArmazenagem"
                                    id="localArmazenagem"
                                    value={
                                        this.state.ivvData.localArmazenagem != undefined &&
                                            this.state.ivvData.localArmazenagem != null &&
                                            this.state.ivvData.localArmazenagem != "" ?
                                            this.state.ivvData.localArmazenagem == 'Gaia' ? 1 :
                                                this.state.ivvData.localArmazenagem == 'Douro' ? 2 :
                                                    this.state.ivvData.localArmazenagem == 'Resto do País' ? 3 :
                                                        this.state.ivvData.localArmazenagem == 'Outro País' ? 4 :
                                                            this.state.ivvData.localArmazenagem : ""

                                    }
                                    onChange={(e) => this.handleChangeIVVForm(e, "formData")}
                                >
                                    <option value="" disabled>
                                        Selecione Local
                                    </option>

                                    {localArmazenagemDropdown.map((row, index) => (
                                        <option key={index} value={row.value}>
                                            {row.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className="col-md-13" style={{ paddingLeft: "0px" }}>
                        <div className="row mt-3">
                            {
                                console.log("1 - ", this.coddis, ", 2 - ", this.codcon, ", 3 - ", this.codfrg)
                            }
                            {/* <LocationSelection
                                    getLocationData={(key, value) => this.getLocationData(key, value)}
                                    date={new Date()}
                                    distrito_id={ this.props.ivvFormData.codfrg&&+this.props.ivvFormData.codfrg.substring(0,2) || ''}
                                    country_id={ this.props.ivvFormData.codfrg&& +this.props.ivvFormData.codfrg.substring(2,4) ||''}
                                    fregusia_id={ this.props.ivvFormData.codfrg&& +this.props.ivvFormData.codfrg.substring(4,6) || ''}
                                    module="Vinica"
                                /> */}
                            <LocationFunction
                                getLocationData={(key, value) => this.getLocationData(key, value)}
                                distrito_id={this.coddis ? parseInt(this.coddis, 10) : ''}
                                country_id={this.codcon ? parseInt(this.codcon, 10) : ''}
                                fregusia_id={this.codfrg ? parseInt(this.codfrg, 10) : ''}
                            />
                            {/* <div className="col-md-3">
                                    <div className="input-box active-grey drop-down-box">
                                        <label className="input-label">Entreposto </label>
                                        <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='idEntreposto' value={this.state.ivvData.idEntreposto || ''} >
                                            <option selected disabled value="">Selecione Entreposto </option>
                                            {
                                                this.props.all_list.EntrepostoDropdown &&
                                                this.props.all_list.EntrepostoDropdown.map((_row, index) => (
                                                    <option key={index} value={_row.idEntreposto}>{_row.nomeEntreposto}</option>
                                                ))
                                            }
                                        </select>
                                        {
                                        this.props.checkMandatoryFields && !this.state.ivvData.idEntreposto &&  
                                        <span className="text-danger">Campo obrigatório</span>
                                        }
                                    </div>
                                </div> */}
                            {
                                this.props.checkMandatoryFields &&
                                (!this.state.data["coddis"] ||
                                    !this.state.data["codcon"] ||
                                    !this.state.data["codfrg"]) &&
                                <span className="text-danger ml-3" style={{ marginTop: "-36px" }}>Campo obrigatório</span>
                            }
                        </div>
                    </div>


                    {/* <div className="col-md-3">
                            <div className="input-box active-grey drop-down-box">
                                <label className="input-label">Distrito </label>
                                <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='coddis' value={this.state.ivvData.coddis || ''} >
                                    <option>Selecione Distrito </option>
                                    {
                                        this.props.all_list.busentdistrito &&
                                        this.props.all_list.busentdistrito.map((_row, index) => (
                                            <option value={_row.coddis}>{_row.desdis}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input-box active-grey drop-down-box">
                                <label className="input-label">Concelho</label>
                                <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='codcon' value={this.state.ivvData.codcon || ''}>
                                    <option>Selecione Concelho</option>
                                    {
                                        this.state.busentconcelho &&
                                        this.state.busentconcelho.map((_row, index) => (
                                            <option value={_row.coddis + "-" + _row.codcon}>{_row.descon}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input-box active-grey drop-down-box">
                                <label className="input-label">Freguesia </label>
                                <select className="custome-drop-down" onChange={(e) => this.handleChangeIVVForm(e, 'formData')} name='codfrg' value={this.state.ivvData.dicofre || ''} >
                                    <option>Selecione Freguesia </option>
                                    {
                                        this.state.BusEntFreguesia &&
                                        this.state.BusEntFreguesia.map((_row, index) => (
                                            <option value={_row.dicofre}>{_row.desfrg}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div> */}





                </div>

                {
                    this.props.isInEdit &&
                    <div className="bg-white middle p20 mt-140 position-relative">

                        <div className="head">
                            <h2 id="Capacidade">Capacidade</h2>
                        </div>
                        <div className="container border pl-5 pt-3 pb-3">
                            <div className="row">
                                <div className="col-md-3 col-sm-6">
                                    <p>Litros</p>
                                    <h4>{this.props.capacidade ?
                                        (this.props.capacidade["total"] ? services.money.format(this.props.capacidade["total"]) : 0) : 0}</h4>
                                </div>
                                <div className="col-md-3 col-sm-6">
                                    <p>Pipas</p>
                                    <h4>{this.props.capacidade ?
                                        (this.props.capacidade["total"] ? services.money.format(Math.round(this.props.capacidade["total"]) / 550) : 0) : 0}</h4>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row d-flex">
                                <div className="col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="autovidante"
                                            type="text"
                                            label="Autovid."
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["autovidante"] ? services.money.format(this.props.capacidade["autovidante"]) : 0) : 0}
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="fibra"
                                            type="text"
                                            label="Fibra"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["fibra"] ? services.money.format(this.props.capacidade["fibra"]) : 0) : 0}
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="balao"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["balao"] ? services.money.format(this.props.capacidade["balao"]) : 0) : 0}
                                            label="Balão"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="balseiro"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["balseiro"] ? services.money.format(this.props.capacidade["balseiro"]) : 0) : 0}
                                            label="Balseiro"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="casco"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["casco"] ? services.money.format(this.props.capacidade["casco"]) : 0) : 0}
                                            label="Casco"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="cascos"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["cascos"] ? services.money.format(this.props.capacidade["cascos"]) : 0) : 0}
                                            label="Cascos"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="inox"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["inox"] ? services.money.format(this.props.capacidade["inox"]) : 0) : 0}
                                            label="Inox"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="plastico"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["plastico"] ? services.money.format(this.props.capacidade["plastico"]) : 0) : 0}
                                            label="Plástico"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="cimento"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["cimento"] ? services.money.format(this.props.capacidade["cimento"]) : 0) : 0}
                                            label="Cimento"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="ferro"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["ferro"] ? services.money.format(this.props.capacidade["ferro"]) : 0) : 0}
                                            label="Ferro"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="subterranea"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["subterranea"] ? services.money.format(this.props.capacidade["subterranea"]) : 0) : 0}
                                            label="Subter."
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="garrafao"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["garrafao"] ? services.money.format(this.props.capacidade["garrafao"]) : 0) : 0}
                                            label="Garrafão"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="garrafas"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["garrafas"] ? services.money.format(this.props.capacidade["garrafas"]) : 0) : 0}
                                            label="Garrafas"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="isotermica"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["isotermica"] ? services.money.format(this.props.capacidade["isotermica"]) : 0) : 0}
                                            label="Isotérm."
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="tonel"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["tonel"] ? services.money.format(this.props.capacidade["tonel"]) : 0) : 0}
                                            label="Tonel"
                                            readonly
                                        />
                                    </div>
                                </div>
                                <div className=" col-md-3 col-sm-12">
                                    <div className="input-box active-grey">
                                        <Input
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="outro"
                                            type="text"
                                            value={this.props.capacidade ?
                                                (this.props.capacidade["outro"] ? services.money.format(this.props.capacidade["outro"]) : 0) : 0}
                                            label="Outro"
                                            readonly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }


                <div className="bg-white middle p20 mt-140 position-relative" id="link4">
                    <span
                        data-toggle="modal"
                        data-target='#left-popup-center'
                        style={!this.props.isInEdit ? { backgroundColor: "grey" }
                            :
                            {}}
                        title="Inserir Vasilha"
                        className="add-plus cursor-pointer"
                        onClick={() => this.openInserirvasilha({})}>
                        <i className="fas fa-plus">
                        </i>
                    </span>

                    <div className="head">
                        <h2 id="Vasilhas"> Vasilhas</h2>
                        {/* <p>lorem ipsum dollar sit amt entuit</p> */}
                    </div>
                    <div>
                        <div classs="col-md-12">

                            {
                                this.props.isInEdit &&
                                <InstalaCaovinicaTables
                                    allVasilha={this.props.allVasilha}
                                    date={this.state.date}
                                    tableName={'Instalações_Vasilhas'}
                                    applyedfilter={this.state.Filters}
                                    id={this.props.id}
                                    isInEdit={this.props.isInEdit}
                                    idInstalacaoVinica={this.props.idInstalacaoVinica || 0}
                                    ActionPerform={(action, row) => this.ActionPerform(action, row)}
                                />
                            }
                        </div>
                    </div>
                    <div className="row mb-0">
                        <div className="col-md-12 mb-0">
                            {!this.props.isInEdit &&
                                <center className="vinica-dados-form-alert" >
                                    <p >
                                        Para inserir dados sobre as vasilhas, deverá submeter primeiro a informação da instalação vínica
                                    </p>
                                </center>}
                        </div>
                    </div>
                </div>
                {this.props.isInEdit &&
                    <div className="modal left-popup" id="left-popup-center">
                        <div className="modal-dialog modal-lg">
                            {this.state.detailPopUp}
                        </div>
                    </div>
                }
                {
                    this.props.historyToggle &&
                    <div className="left-popup" id="history-popup-center">
                        <div className="modal-dialog modal-lg">
                            <HistoryPanel handleHistoryToggle={() => this.props.handleHistoryToggle()} />
                        </div>
                    </div>
                }

            </div>
        )
    }
}


export default WizardVínica;